import React from 'react';

function SelectedCompanyItem(item) {
  return (
    <div className="selected_company">
      <p className="selected_company_title">{item?.title}</p>
      <p className="selected_company_desc">{item?.descr}</p>
      <p className="selected_company_info">{item?.address}</p>
    </div>
  );
}

export default SelectedCompanyItem;
